<template>
    <div>
        <!-- confirm modal -->
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-confirm"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base"
                :class="{'farmer': theme == 'farmer', 'subdist': theme == 'subdist', 'dist': theme == 'dist', 'sale': theme == 'sale'}">
                <div class="modal-base-head">
                    <p id="confirm_modal_title" class="confirm-modal-txt theme-txt" v-html="title"></p>
                </div>
                <div id="confirm_modal_body" class="modal-base-body">
                    <p class="modal-body-txt" :class="{'modal-unregister': tag =='profile-unsubscript'}" v-html="message"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="confirm_modal_error" v-if="message_error" v-html="message_error"></div>
                    <div id="confirm_modal_big_btn_row" v-if="tag == 'marketing-confirm'">
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper btn-disable" v-if="message_error">
                                <div class="btn-txt">
                                    {{btnOk}}
                                </div>
                            </div>
                            <div class="btn-wrapper" v-else>
                                <div class="btn-txt"
                                    @click="clickOk()">
                                    {{btnOk}}
                                </div>
                            </div>
                        </div>
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper btn-cancel">
                                <div class="btn-txt"
                                    @click="clickCancel()">
                                    {{btnCancel}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="confirm_modal_btn_row" v-else>
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper btn-cancel">
                                <div class="btn-txt"
                                    @click="clickCancel">
                                    {{btnCancel}}
                                </div>
                            </div>
                        </div>
                        <div class="conform-modal-btn">
                            <div class="btn-wrapper btn-disable" v-if="message_error">
                                <div class="btn-txt">
                                    {{btnOk}}
                                </div>
                            </div>
                            <div class="btn-wrapper" v-else>
                                <div class="btn-txt"
                                    @click="clickOk">
                                    {{btnOk}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "ConfirmModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
        theme: String
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            message_error: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.message_error = config.msg_error;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            if (Util.isEmptyStr(config.btnCancel)) {
                this.btnCancel = this.lbl.default.cancel;
            }

            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";
    .modal-confirm {
        @extend %modal-base;

        #confirm_modal_head {
            padding: 10px 10px 0;
        }

        #confirm_modal_body {
            padding: 15px 0 30px;
        }
    }
</style>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    #confirm_modal_title {
        font-size: 1.65rem;

        @media (max-width: $max-width-mini-mobile) {
            font-size: 1.45rem;
        }
    }

    .confirm-modal-txt {
        margin-bottom: 0;
        text-align: center;
    }

    #confirm_modal_error{
        font-size: 1.3rem;
        color: $red;
        text-align: center;
        padding: {
            bottom: 5px;
        }
    }

    #confirm_modal_btn_row {
        @extend %display-flex;
        width: 100%;
        padding-bottom: 7px;

        .conform-modal-btn {
            width: 50%;
            flex: 0 0 50%;

            &:nth-child(1) {
                padding-right: 3px;
            }

            &:nth-child(2) {
                padding-left: 3px;
            }
        }
     }
     #confirm_modal_big_btn_row {
        width: 100%;
        padding-bottom: 7px;

        .conform-modal-btn {
            width: 100%;
            flex: 0 0 100%;
            padding-top: 12px;
            .btn-txt {
                padding: 0 10px;
            }
        }
     }
</style>
